export enum ContentPageId {
  accounttriage = 'accounttriage',
  assumeinherit = 'assumeinherit',
  benedetails = 'benedetails',
  benerelationship = 'benerelationship',
  cancel = 'cancel',
  clientduediligence = 'clientduediligence',
  confirm = 'confirm',
  contactinfo = 'contactinfo',
  daenroll = 'daenroll',
  daoffer = 'daoffer',
  dateofbirth = 'dateofbirth',
  dateofdeath = 'dateofdeath',
  decedent = 'decedent',
  decedentid = 'decedentid',
  documentupload = 'documentupload',
  letterupload = 'letterupload',
  employment = 'employment',
  error = 'error',
  estate = 'estate',
  giftingassets = 'giftingassets',
  giftingconfirm = 'giftingconfirm',
  giftingintelledoxredirect = 'giftingintelledoxredirect',
  giftingmethod = 'giftingmethod',
  giftingoverview = 'giftingoverview',
  giftingrecipient = 'giftingrecipient',
  giftingrecipienttriage = 'giftingrecipienttriage',
  giftingsummary = 'giftingsummary',
  giftingtriage = 'giftingtriage',
  guide = 'guide',
  incomenetworth = 'incomenetworth',
  ineligible = 'ineligible',
  inheritanceoverview = 'inheritanceoverview',
  internaltransferconfirm = 'internaltransferconfirm',
  internaltransfercostbasisoptin = 'internaltransfercostbasisoptin',
  internaltransferdifferentownerrecipient = 'internaltransferdifferentownerrecipient',
  internaltransferexpired = 'internaltransferexpired',
  internaltransferfrom = 'internaltransferfrom',
  internaltransferdetails = 'internaltransferdetails',
  internaltransferholdingsreview = 'internaltransferholdingsreview',
  internaltransferopenaccount = 'internaltransferopenaccount',
  internaltransferoverview = 'internaltransferoverview',
  internaltransfersummary = 'internaltransfersummary',
  internaltransferto = 'internaltransferto',
  internaltransfertriage = 'internaltransfertriage',
  investmentobjectives = 'investmentobjectives',
  investmentstrategy = 'investmentstrategy',
  inheritediratriage = 'inheritediratriage',
  iratype = 'iratype',
  minoroverview = 'minoroverview',
  multiaccountenrollemnt = 'multiaccountenrollment',
  namecomponent = 'namecomponent',
  newaccountreview = 'newaccountreview',
  personalinfo = 'personalinfo',
  receipt = 'receipt',
  review = 'review',
  riskquizsetup = 'riskquizsetup',
  riskquizresults = 'riskquizresults',
  samplePageId = 'samplePageId',
  shared = 'shared',
  taxFilingRetirement = 'taxFilingRetirement',
  tcftrustsign = 'tcftrustsign',
  termsexisting = 'termsexisting',
  termsnew = 'termsnew',
  termsgifting = 'termsgifting',
  testmonkey = 'testmonkey',
  transferfrom = 'transferfrom',
  transferto = 'transferto',
  triage = 'triage',
  triagesummary = 'triagesummary',
  trustinfo = 'trustinfo',
  trusttaxinfo = 'trusttaxinfo',
  trusttriage = 'trusttriage',
  trusttotrustinfo = 'trusttotrustinfo',
  unittest = 'unittest',
  zipcode = 'zipcode',
  settlementfund = 'settlementfund',
  multitriage = 'multitriage',
  multitrusttriage = 'multitrusttriage',
  multitermsnew = 'multitermsnew',
}
